<template>
  <section>
    <modal-history-funil :callCheckRequest="callCheckRequest"/>
    <modal-open-ticket :dataCompanyModal="dataCompanyModal"/>
    <modal-default modal-title="Editar em massa" modal-id="editTicketsSelected" width="50%">
      <template>
        <div>
          <div class="col-md-6 edit-tickets-modal">
            <input-checkbox :is-checked="false" col="0" label="Responsáveis"
                            @valueCheckbox="value => dataCode.responsibles.isChecked = value"/>
            <input-multi-select-own
              v-bind:style="{ 'pointer-events': dataCode.responsibles.isChecked ? 'auto' : 'none' }"
              margin-space="0 0 20px 0" col="0" is-name="true" :list-items="listFilters.responsibles"
              @selectedString="value => dataCode.responsibles.id = value"/>
          </div>
          <div class="col-md-6 edit-tickets-modal">
            <input-checkbox class="input" :is-checked="false" col="0" label="Etapa"
                            @valueCheckbox="value => dataCode.stage.isChecked = value"/>
            <input-select v-bind:style="{ 'pointer-events': dataCode.stage.isChecked ? 'auto' : 'none' }" col="0"
                          :options="listFilters.stages" label=""
                          @selectedOption="value => dataCode.stage.stageId = value"/>
          </div>

          <div class="col-md-6 edit-tickets-modal">
            <input-checkbox :is-checked="false" col="0" label="Tags"
                            @valueCheckbox="value => dataCode.tags.isChecked = value"/>
            <input-multi-select-own v-bind:style="{ 'pointer-events': dataCode.tags.isChecked ? 'auto' : 'none' }"
                                    margin-space="0 0 20px 0" col="0" is-name="true" :list-items="listFilters.tags"
                                    @selectedString="value => dataCode.tags.tagsId = value"/>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 edit-tickets-modal">
            <label>
              <input-checkbox :is-checked="false" col="0" label="Prazo de entrega"
                              @valueCheckbox="value => dataCode.deadLine.isChecked = value"/>
            </label>
            <div class="input-with-date">
              <datepicker input-class="width-full"
                          v-bind:style="{ 'pointer-events': dataCode.deadLine.isChecked ? 'auto' : 'none' }"
                          ref="programaticOpen4" v-model="dataCode.deadLine.date" :language="ptBR"
                          :format="customFormatter"/>
              <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
            </div>
          </div>
          <btn-custom which-side="right" :have-loading="true" :loading="loadingEdit" label="Salvar" col="12"
                      @emit-click="saveEditTickets()"/>
        </div>
      </template>
    </modal-default>
    <!-- top-menu -->
    <top-menu/>
    <!-- tickets -->
    <div class="page-content tickets-content">
      <div class="container-fluid">
        <div class="page-content-inner">
          <!-- Cards -->
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>
            <!-- Header -->
            <div v-if="!loadingList" class="col-md-12 header">
              <div class="header__content">
                <div class="header__content--balance">
                  Total de tickets: <span>{{ numbers.total }}</span>
                </div>
                <div class="header__content--cards">
                  <div class="header__content--cards--total">
                    <div class="circle-orange"></div>
                    Em progresso: <span>{{ numbers.inProgress }}</span>
                  </div>
                  <div class="header__content--cards--total">
                    <div class="circle-green"></div>
                    Concluídos: <span>{{ numbers.done }}</span>
                  </div>
                  <div class="header__content--cards--total">
                    <div class="circle-gray"></div>
                    Arquivados: <span>{{ numbers.filed }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Numbers -->
            <div v-if="!loadingList" class="col-md-12 cards-dashboard bg-classic-white">
              <div class="cards-dashboard-group dragscroll">
                <span v-if="!loadingNumber" class="reloadIcon" @click="getDashboardNumbers">
                  <ion-icon name="refresh-outline"></ion-icon>
                </span>
                <div v-if="!loadingNumber" class="dashboard-content" v-for="(value, index) in numbers.dashResume"
                     v-bind:key="index">
                  <span class="content-text">{{ value.name }}</span>
                  <span class="content-number">
                    <div class="point-blue"></div>
                    {{ value.value }}
                  </span>
                </div>
              </div>
              <div v-if="loadingNumber" class="cards-dashboard-group">
                <div class="loading-number">
                  <full-loading v-if="loadingNumber"/>
                </div>
              </div>
            </div>
            <!-- List Content-->
            <div v-if="!loadingList" class="col-md-12 default-box-filter bg-classic-white">
              <!-- Filters -->
              <div class="col-md-12 filter-card">
                <div class="filter-card-header">
                  <div class="title-filter">
                    <label class="label-ticket-filter">
                      <ion-icon name="ticket-outline" v-on:click="funFunction()"/>
                      Tickets
                    </label>
                    <span>Gerencie os tickets criados</span>
                  </div>
                  <!--                  <span class="change-history">-->
                  <!--                    <a v-on:click="openHistory()">-->
                  <!--                      Visualizar histórico de alteração-->
                  <!--                    </a>-->
                  <!--                  </span>-->
                </div>
                <form class="form-group-ticket">
                  <div class="col-md-12 group-ticket">
                    <div class="col-md-12 group-ticket-1">
                      <div class="col-md-4 input-ticket-1">
                        <label>Nome do ticket</label>
                        <div class="form-ticket-1-input">
                          <input v-model="dataSearch.titleName" type="text" placeholder="Digite"/>
                          <ion-icon name="search-outline"></ion-icon>
                        </div>
                      </div>
                      <div class="col-md-4 input-ticket-2">
                        <input-select-search col="0" label="Responsável" :list-items="listFilters.responsibles"
                                             @selectedString="value => dataSearch.responsableId = value"/>
                      </div>
                      <div class="col-md-4 input-ticket-3">
                        <label>Empresa</label>
                        <div class="input-ticket-3-select">
                          <input-checkbox :is-checked="companyDisabled" col="0" label="Pesquisar desativadas"
                                          @valueCheckbox="value => companyDisabled = value"/>
                          <autocomplete :selected-company-id="companyId" :value="listCompanyFiltered" :type="1"/>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 group-ticket-2">
                      <div class="col-md-4 input-ticket-4">
                        <input-multi-select-own col="0" :is-ordened="false" :list-items="listFilters.stages"
                                                label="Etapa" is-name="true"
                                                :have-search="false"
                                                @selectedString="value => dataSearch.stageId = value"/>
                        <!--                        <label>Etapa</label>-->
                        <!--                        <div class="input-ticket-4-select">-->
                        <!--                          -->
                        <!--                                                    <select id="stageId" v-model="dataSearch.stageId">-->
                        <!--                                                      <option value="">Selecione</option>-->
                        <!--                                                      <option v-for="(ci, index) in listFilters.stages" v-bind:key="index"-->
                        <!--                                                              v-bind:id="'stages' + index" v-bind:name="'stages' + index" v-bind:value="ci.id">-->
                        <!--                                                        {{ ci.name }}-->
                        <!--                                                      </option>-->
                        <!--                                                    </select>-->
                        <!--                          <ion-icon name="chevron-down-outline"></ion-icon>-->
                        <!--                        </div>-->
                      </div>
                      <div class="col-md-4 input-ticket-5">
                        <input-multi-select-own col="0" is-name="true" :list-items="listFilters.tags" label="Tags"
                                                @selectedString="value => dataSearch.tagId = value"/>
                      </div>
                      <div class="col-md-4 input-ticket-6">
                        <label>Filtrar por data de:</label>
                        <div class="input-ticket-6-select">
                          <select v-model="dataSearch.deadLine">
                            <option value="false">Data de Criação
                            </option>
                            <option value="true">Prazo de entrega</option>
                          </select>
                          <ion-icon name="chevron-down-outline"></ion-icon>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 group-ticket-3">
                      <div class="col-md-4 input-ticket-7">
                        <div class="input-group">
                          <datapicker-global col="12" label="Data Inicial / Final"
                                             rangeDaysInit="7" haveRangeDaysMax="false" variableName="date"
                                             padding-null="true"/>
                        </div>
                      </div>
                      <div class="col-md-4 input-ticket-8">
                        <label>Em atraso</label>
                        <div class="input-ticket-8-select">
                          <select v-model="dataSearch.isLate">
                            <option value="true">Sim
                            </option>
                            <option value="false">Não</option>
                          </select>
                          <ion-icon name="chevron-down-outline"></ion-icon>
                        </div>
                      </div>
                      <div class="col-md-4 input-ticket-9">
                        <label>Entregar em breve</label>
                        <div class="input-ticket-9-select">
                          <select v-model="dataSearch.isDeliver">
                            <option value="true">Sim
                            </option>
                            <option value="false">Não</option>
                          </select>
                          <ion-icon name="chevron-down-outline"></ion-icon>
                        </div>
                      </div>
                      <div class="col-md-4 input-ticket-10">
                        <input-checkbox :is-checked="false" col="0" label="Exibir tickets arquivados"
                                        @valueCheckbox="value => dataSearch.hideArchived = !value"/>
                      </div>
                    </div>
                  </div>
                </form>
                <div class="col-md-12 btn-filter">
                  <button class="btn-ticket" v-on:click="getDashboardTicketsFiltered(true)">Pesquisar</button>
                  <div class="grid-button">
                    <button v-on:click="registerTicket()" class="btn-create-ticket">
                      <ion-icon name="add-outline"></ion-icon>
                      Novo ticket
                    </button>
                    <button class="btn-2" @click="openModalEditTickets()">Editar em massa</button>
                  </div>
                </div>
              </div>
              <!-- No Result -->
              <div v-if="!loadingList && !loadingListTable && dataLog !== '' && !dataLog.length && !failRequest"
                   class="col-md-12">
                <div class="col-md-12 default-box-filter content-default no-result-box">
                  <p>Sem resultado na pesquisa.</p>
                </div>
              </div>
              <!-- Fail Request -->
              <div v-if="!loadingList && !loadingListTable && failRequest" class="col-md-12">
                <div class="col-md-12 default-box-filter content-default">
                  <p>Falha na requisição.</p>
                </div>
              </div>

              <!-- Table -->
              <div v-if="!loadingListTable && dataLog.length" class="col-md-12 table-box--content">
                <input-checkbox :is-checked="false" col="0" label="Selecionar todos"
                                @valueCheckbox="value => allChecked = value"/>
                <table class="content-table">
                  <thead>
                  <tr>
                    <th>
                      Título
                      <!--                        <ion-icon id="title" name="caret-down-outline"-->
                      <!--                                  v-on:click="orderSort('title')"></ion-icon>-->
                    </th>
                    <th>
                      Empresa
                      <!--                        <ion-icon id="title" name="caret-down-outline"-->
                      <!--                                  v-on:click="orderSort('title')"></ion-icon>-->
                    </th>
                    <th>
                      Etapa
                      <ion-icon id="stageName" name="caret-down-outline"
                                v-on:click="orderSort('stageName')"></ion-icon>
                    </th>
                    <th>
                      Etapa da empresa
                    </th>
                    <th>
                      Responsáveis
                      <ion-icon id="responsiblesName" name="caret-down-outline"
                                v-on:click="orderSort('responsiblesName')"></ion-icon>
                    </th>
                    <th style="text-align: center;">
                      Data de criação
                      <ion-icon id="createdAt" name="caret-down-outline"
                                v-on:click="orderSort('createdAt')"></ion-icon>
                    </th>
                    <th style="text-align: center; padding: 0 40px">
                      Prazo
                      <ion-icon id="deadLine" name="caret-down-outline" v-on:click="orderSort('deadLine')"></ion-icon>
                    </th>
                    <th style="text-align: center;">
                      Última ação
                      <ion-icon id="updatedAt" name="caret-down-outline"
                                @click="orderSort('updatedAt')"></ion-icon>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(value, index) in dataLog" :key="index">
                    <td class="content-table--company-name">
                      <div class="ticket-name">
                        <input type="checkbox" :id="'value-' + index" v-model="value.isChecked">
                        <a :href="'/lista-de-ticket/' + value.ticketId" target="_blank" :title="value.title">
                          {{ value.title }}
                        </a>
                      </div>
                    </td>
                    <td class="content-table--company-name">
                      <a v-if="value.companyName"
                         :href="'/detalhes-da-empresa/' + value.companyId + '/' + value.contentSetting"
                         target="_blank" :title="value.companyName">
                        {{ value.companyName }}
                      </a>
                    </td>
                    <td class="content-table--company-name">
                      <span :title="value.stageName">{{ value.stageName }}</span>
                    </td>
                    <td class="content-table--company-name">
                      <span>{{ value.journey }}</span>
                    </td>
                    <td class="content-table--company-name">
                        <span v-for="i in value.responsiblesName">
                          {{ i }}
                        </span>
                    </td>
                    <td class="content-table--created">
                      <span>{{ value.createdAtStr }}</span>
                    </td>
                    <td class="content-table--created"
                        :class="value.isLate ? 'content-table-deadline' : ''">
                      <span>{{ value.deadLineStr }}</span>
                      <span class="is-late" v-if="value.isLate">Em atraso</span>
                    </td>
                    <td class="content-table--created">
                      <span>{{ value.updatedAt | formatDate }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- Loading from page -->
              <full-loading class="loading-list-table" v-if="loadingListTable"/>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- footer-menu -->
    <footer-menu v-if="!loadingList"/>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import footerMenu from "../../components/default/footerMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import {
  CHANGE_TICKETS_FILTERS,
  CHANGE_TICKETS_NUMBERS,
  CHANGE_TICKETS_TICKETS,
  UPDATE_TICKETS_BULK,
} from "../../../../urlConfig";
import {REQUEST_SERVICE} from "../../../../requestConfig";
import {UTIL_SERVICE} from "../../../../utils";
import {ALERT_SERVICE} from "../../../../msgAlertService";
import modalOpenTicket from "../../modals/modalOpenTicket.vue";
import modalHistoryFunil from "../../modals/modalHistoryFunil.vue";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import datapickerGlobal from '../../components/inputs/datapickerGlobal.vue';
import autocomplete from "../../components/inputs/inputAutocomplete.vue";
import moment from "moment";
import InputMultiSelect from "../../components/inputs/inputMultiSelect.vue";
import BtnCustom from "../../components/buttons/btnCustom.vue";
import ModalDefault from "../../components/modals/modalDefault.vue";
import InputSelect from "../../components/inputs/inputSelect.vue";
import InputMultiSelectOwn from "../../components/inputs/inputMultiSelectOwn.vue";
import swal from "sweetalert";
import InputCheckbox from "../../components/inputs/inputCheckbox.vue";
import InputSelectSearch from "../../components/inputs/inputSelectSearch.vue";

export default {
  name: "tickets",
  components: {
    InputSelectSearch,
    InputMultiSelect,
    InputMultiSelectOwn,
    InputCheckbox,
    InputSelect,
    ModalDefault,
    BtnCustom,
    topMenu,
    footerMenu,
    fullLoading,
    modalOpenTicket,
    datepicker,
    modalHistoryFunil,
    datapickerGlobal,
    autocomplete,
  },
  data() {
    return {
      callCheckRequest: "",
      // orderByValue: "title",
      ptBR: ptBR,
      failRequest: false,
      loadingList: false,
      loadingListTable: false,
      dataLog: [],
      dataCode: {
        responsibles: {
          id: '',
          isChecked: false,
        },
        stage: {
          stageId: '',
          isChecked: false,
        },
        tags: {
          tagsId: [],
          isChecked: false,
        },
        deadLine: {
          date: '',
          isChecked: false,
        },
      },
      numbers: {},
      dataCompanyModal: "",
      listFilters: {},
      listCompanyFiltered: {},
      dataSearch: {
        useConclusionDate: "",
        responsableId: "",
        tagId: "",
        stageId: "",
        titleName: "",
        deadLine: "false",
        isLate: "false",
        isDeliver: "false",
        hideArchived: true,
      },
      funVar: 0,
      selectOptions: [],
      allChecked: false,
      userInfo: '',
      loadingEdit: false,
      companyDisabled: false,
      companyId: this.$route.params.id,
      loadingNumber: false,
    };
  },
  methods: {
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    saveEditTickets() {
      this.loadingEdit = true;

      const selectedTickets = this.dataLog.filter(({isChecked}) => isChecked === true);

      const selectedTicketsId = selectedTickets.map(value => {
        return value.ticketId
      })

      if (!this.dataCode.stage.isChecked) {
        this.dataCode.stage.stageId = null;
      }

      if (!this.dataCode.deadLine.isChecked) {
        this.dataCode.deadLine.date = null;
      }

      if (!this.dataCode.tags.isChecked) {
        this.dataCode.tags.tagsId = null;
      }

      if (!this.dataCode.responsibles.isChecked) {
        this.dataCode.responsibles.id = null;
      }

      let obj = {
        whoCreatedId: this.userInfo.id,
        ids: selectedTicketsId,
        editResponsibles: this.dataCode.responsibles.isChecked,
        responsibleIds: this.dataCode.responsibles.id,
        editStage: this.dataCode.stage.isChecked,
        stageId: this.dataCode.stage.stageId,
        editTags: this.dataCode.tags.isChecked,
        tagsId: this.dataCode.tags.tagsId,
        editDeadline: this.dataCode.deadLine.isChecked,
        deadline: this.dataCode.deadLine.date,
      }

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TICKETS_BULK, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TICKETS:", response.data);
        this.loadingEdit = false;
        $('#editTicketsSelected').modal('hide')
        swal("Aviso", "Alterado com Sucesso!", "success");
        this.getDashboardTickets();
      }).catch((reason) => {
        this.loadingEdit = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    openModalEditTickets() {
      $('#editTicketsSelected').modal()
    },
    openHistory() {
      this.callCheckRequest = Math.floor(Math.random() * 500);

      $("#modalHistoryFunil").modal();
    },
    registerTicket(value) {
      this.dataCompanyModal = {};
      this.dataCompanyModal.listFilters = this.listFilters;
      this.dataCompanyModal.math = Math.floor(Math.random() * 500);
      this.$route.params.selectedIdTicket = ''

      $("#modalOpenTicket").modal();
    },
    getDashboardNumbers() {
      this.loadingNumber = true;

      let url = CHANGE_TICKETS_NUMBERS;
      REQUEST_SERVICE.requestContext("GET", url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_TICKETS_NUMBERS:", response.data);

          this.numbers = response.data;
          this.numbers.dashResume = this.numbers.dashResume.filter(value => value.name !== 'Triagem P');
          this.loadingNumber = false;
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
          this.loadingNumber = false;
        });
    },
    getDashboardTicketsFiltered(search) {
      if (this.dataSearch.deadLine) {
        this.loadingListTable = true;

        let url = CHANGE_TICKETS_TICKETS;
        url += "&page=0";
        url += "&rows=999999";
        url += "&isLate=" + this.dataSearch.isLate;
        url += "&isDeliver=" + this.dataSearch.isDeliver;
        url += "&isDeadline=" + this.dataSearch.isLate;
        url += "&deliverSoon=" + this.dataSearch.isDeliver;
        url += "&hideArchived=" + this.dataSearch.hideArchived;

        if (search) {
          url += "&init=" + this.$route.params.dateInit;
          url += "&end=" + this.$route.params.dateEnd;
        } else {
          const date = new Date();
          const init = moment(date).subtract(7, 'days').format('YYYY-MM-DD')
          const end = moment(date).format('YYYY-MM-DD')

          url += "&init=" + init;
          url += "&end=" + end;
        }

        if (this.dataSearch.titleName)
          url += "&title=" + this.dataSearch.titleName;

        if (this.dataSearch.responsableId)
          url += "&responsableId=" + this.dataSearch.responsableId;

        if (this.dataSearch.stageId)
          url += "&stageIds=" + this.dataSearch.stageId;

        if (this.$route.params.selectedIdTicket) {
          url += "&companyId=" + this.$route.params.selectedIdTicket;
        }

        if (this.dataSearch.tagId)
          url += "&tags=" + this.dataSearch.tagId;

        if (this.dataSearch.deadLine)
          url += "&useConclusionDate=" + this.dataSearch.deadLine;

        UTIL_SERVICE.console("URL SEARCH:", url);

        REQUEST_SERVICE.requestContext("GET", url)
          .then((response) => {
            UTIL_SERVICE.console(
              "RESULT CHANGE_TICKETS_TICKETS:",
              response.data
            );

            this.dataLog = response.data.items;

            this.dataLog = this.dataLog.map((row) => {
              row.tags = row.tags.sort(function (a, b) {
                let valueA = a['name'];
                let valueB = b['name'];
                if (valueA > valueB) {
                  return 1;
                }
                if (valueA < valueB) {
                  return -1;
                }
                return 0;
              })
              return row
            })

            this.failRequest = false;
            this.loadingListTable = false;
          })
          .catch((reason) => {
            this.failRequest = true;
            this.loadingListTable = false;
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      } else {
        swal(
          "Aviso",
          "Selecione 'data de criação' ou 'data de conclusão' para continuar",
          "error"
        );
      }
    },
    getDashboardTickets(search) {

      if (this.dataSearch.deadLine) {
        this.loadingList = true;

        let url = CHANGE_TICKETS_TICKETS;
        url += "&page=0";
        url += "&rows=999999";
        url += "&isLate=" + this.dataSearch.isLate;
        url += "&isDeliver=" + this.dataSearch.isDeliver;
        url += "&isDeadline=" + this.dataSearch.isLate;
        url += "&deliverSoon=" + this.dataSearch.isDeliver;
        url += "&hideArchived=" + this.dataSearch.hideArchived;

        if (search) {
          url += "&init=" + this.$route.params.dateInit;
          url += "&end=" + this.$route.params.dateEnd;
        } else {
          const date = new Date();
          const init = moment(date).subtract(7, 'days').format('YYYY-MM-DD')
          const end = moment(date).format('YYYY-MM-DD')

          url += "&init=" + init;
          url += "&end=" + end;
        }

        if (this.dataSearch.titleName)
          url += "&title=" + this.dataSearch.titleName;

        if (this.dataSearch.responsableId)
          url += "&responsableId=" + this.dataSearch.responsableId;

        if (this.dataSearch.stageId)
          url += "&stageId=" + this.dataSearch.stageId;

        if (this.dataSearch.tagId) {
          this.dataSearch.tagId.join(',')
          url += "&tags=" + this.dataSearch.tagId;
        }

        if (this.$route.params.id)
          url += "&companyId=" + this.$route.params.id;

        if (this.dataSearch.deadLine)
          url += "&useConclusionDate=" + this.dataSearch.deadLine;

        UTIL_SERVICE.console("URL SEARCH:", url);

        REQUEST_SERVICE.requestContext("GET", url)
          .then((response) => {
            UTIL_SERVICE.console(
              "RESULT CHANGE_TICKETS_TICKETS:",
              response.data
            );
            this.dataLog = response.data.items;

            this.dataLog = this.dataLog.map((row) => {
              row.tags = row.tags.sort(function (a, b) {
                let valueA = a['name'];
                let valueB = b['name'];
                if (valueA > valueB) {
                  return 1;
                }
                if (valueA < valueB) {
                  return -1;
                }
                return 0;
              })
              return row
            })

            this.dataLog = this.dataLog.map(data => {
              return {...data, isChecked: false};
            })

            this.failRequest = false;
            this.loadingList = false;
          })
          .catch((reason) => {
            this.failRequest = true;
            this.loadingList = false;
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      } else {
        swal(
          "Aviso",
          "Selecione 'data de criação' ou 'data de conclusão' para continuar",
          "error"
        );
      }
    },
    changeValueEmployees(value) {
      if (value) {
        this.listCompanyFiltered = this.listFilters.companies
      } else {
        this.listCompanyFiltered = this.listFilters.companies.filter(obj => obj.active === true);
      }
    },
    getDashboardFilters() {
      let url = CHANGE_TICKETS_FILTERS;
      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext("GET", url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_TICKETS_FILTERS:", response.data);
          this.listFilters = response.data;

          this.listFilters.responsibles.unshift({id: '', name: 'Selecione'});
          this.listFilters.stages = this.listFilters.stages.filter((value) => value.name !== 'Triagem P');


          if (this.$route.params.isActive == 1) {
            this.listCompanyFiltered = this.listFilters.companies
          } else {
            this.listCompanyFiltered = this.listFilters.companies.filter(obj => obj.active === true);
          }

          this.listFilters.tags.map((value) => {
            this.selectOptions.push({
              id: value.id,
              label: value.name
            })
          })

        })
        .catch((reason) => {
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
    },
    orderSort(value) {
      $('#title').css('transform', 'rotate(0deg)');
      $('#stageName').css('transform', 'rotate(0deg)');
      $('#responsiblesName').css('transform', 'rotate(0deg)');
      $('#deadLine').css('transform', 'rotate(0deg)');
      $('#createdAt').css('transform', 'rotate(0deg)');
      $('#updatedAt').css('transform', 'rotate(0deg)');

      this.dataLog = this.dataLog.sort(function (a, b) {
        let valueA = a[value];
        let valueB = b[value];
        if (typeof valueA === 'string') {
          valueA = valueA.toLowerCase().trim();
        }

        if (typeof valueB === 'string') {
          valueB = valueB.toLowerCase().trim();
        }

        if (valueA > valueB) {
          return 1;
        }
        if (valueA < valueB) {
          return -1;
        }
        return 0;
      });

      if (this[value + 'Order'] === true) {
        this.dataLog.reverse();
        $('#' + value).css('transform', 'rotate(0deg)');
      } else {
        $('#' + value).css('transform', 'rotate(180deg)');
      }

      this[value + 'Order'] = !this[value + 'Order']
    },
    funFunction() {
      if (this.funVar === 5) {

        alert('Você foi sorteado!!!')
        this.funVar = 0

      } else {
        this.funVar = this.funVar + 1
      }
    },
  },
  watch: {
    allChecked() {
      this.dataLog.forEach(item => {
        item.isChecked = this.allChecked;
      })
    },
    companyDisabled(newValue, oldValue) {
      this.changeValueEmployees(newValue)
    }
  },
  beforeMount() {
    this.getDashboardNumbers();
    this.getDashboardFilters();
    this.getDashboardTickets();

    if (this.$route.params.isActive == '1') {
      this.companyDisabled = true;
    }

    this.userInfo = JSON.parse(
      window.localStorage.getItem("mamUserMasterInfo")
    );
  },
};
</script>

<style lang="scss" scoped>
$classic-white: #FFFFFF;
$classic-input: #EEF2F7;
$light-grey: #969696;
$light-black: #3A424E;
$light-blue: #2F23D6;
$light-blue-hover: #251BAD;
$light-purple: #A313BB;
$light-pink: #FF2CC4;
$light-orange: #FF9900;
$light-yellow: #F9CA04;
$light-red: #FF445D;
$light-green: #2ACC6B;
$light-green-hover: #3FB55E;
$light-green-yellow: #A1E80A;
$light-cyan: #00B6DE;

$colors: (classic-white: #FFFFFF !important,
  classic-input: #EEF2F7 !important,
  light-grey: #969696 !important,
  light-black: #3A424E !important,
  light-blue: #2F23D6 !important,
  light-purple: #A313BB !important,
  light-pink: #FF2CC4 !important,
  light-orange: #FF9900 !important,
  light-red: #FF445D !important,
  light-green: #2ACC6B !important,
  light-cyan: #00B6DE !important,
);

@mixin gen-props($prefix, $property) {

  @each $color-name,
  $color in $colors {
    .#{$prefix}-#{$color-name} {
      #{$property}: $color
    }
  }
}

@include gen-props("border", "border-color");
@include gen-props("text", "color");
@include gen-props("bg", "background");


.input-with-date {
  width: 100%;

  .fa-calendar:before {
    position: absolute;
    top: 4px;
    right: 12px;
    pointer-events: none;
  }
}

.vdp-datepicker {
  input {
    width: 100% !important;
  }
}

.edit-tickets-modal {

  label {
    margin-bottom: 20px;
  }

  .custom-checkbox {
    margin-bottom: -30px;
  }
}


.tickets-content {
  .header {
    padding: 0;

    .header__content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      border-bottom: 1px solid var(--border-gray);
      margin-bottom: 20px;
      padding-bottom: 10px;
      margin-top: 6px;

      .header__content--balance {
        font-size: 18px;
        font-weight: 700;
        color: var(--classic-black);

        span {
          font-size: 18px;
          font-weight: 400;
          color: var(--dark-gray);
        }
      }

      .header__content--cards {
        display: flex;
        align-items: center;

        .header__content--cards--total {
          display: flex;
          align-items: baseline;

          margin-left: 25px;
          font-size: 18px;
          font-weight: 700;
          color: var(--dark-gray);

          .circle-orange {
            width: 12px;
            height: 12px;
            border-radius: 50% !important;
            background-color: #FF9900;
            margin-right: 8px;
          }

          .circle-green {
            width: 12px;
            height: 12px;
            border-radius: 50% !important;
            background-color: #2ACC6B;
            margin-right: 8px;
          }

          .circle-gray {
            width: 12px;
            height: 12px;
            border-radius: 50% !important;
            background-color: #7F8897;
            margin-right: 8px;
          }

          span {
            margin-left: 5px;
            font-size: 18px;
            font-weight: 400;
            color: var(--dark-gray);
          }
        }
      }
    }
  }

  .cards-dashboard {
    padding: 20px 30px;
    margin-bottom: 30px;
    border-radius: 10px !important;

    .cards-dashboard-group {
      display: flex;
      justify-content: space-around;
      flex-direction: row;
      overflow-x: auto;

      .loading-number {
        margin: 0 auto;

        .loader-page-content {
          min-height: 60px;
        }
      }

      .reloadIcon {
        position: absolute;
        background: #efefef;
        border-radius: 50% !important;
        text-align: center;
        width: 24px;
        height: 24px;
        top: 8px;
        right: 8px;
        cursor: pointer;

        &:hover {
          background: #dedede;
        }

        ion-icon {
          font-size: 16px;
          margin: 3px auto;
        }
      }

      .dashboard-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: 0 30px 24px 30px;

        .content-text {
          display: flex;
          align-items: center;
          justify-content: center;

          height: 100%;
          font-weight: 700;
          font-size: 16px;
          color: #191919;
          text-align: center;
        }

        .content-number {
          margin-top: 5px;
          font-size: 21px;
          font-weight: 700;
          color: var(--dark-gray);
          text-align: center;

          .point-blue {
            width: 10px;
            height: 10px;
            border-radius: 50% !important;
            background-color: var(--classic-blue);
            margin: auto auto 16px auto;
          }
        }
      }
    }

    .cards-dashboard-group::-webkit-scrollbar {
      height: 4px;
      position: absolute;
    }

    .cards-dashboard-group::-webkit-scrollbar-track {
      background-color: #EEF2F7;
      height: 4px;
      border-radius: 6px;
    }

    .cards-dashboard-group::-webkit-scrollbar-thumb {
      background: #3A424E;
      border-radius: 6px;
    }

    .cards-dashboard-group::-webkit-scrollbar-thumb:hover {
      background: lighten(#3A424E, 5%);
      transition: 0.5s;

    }
  }

  .default-box-filter {
    border-radius: 10px !important;
    padding: 20px 30px;

    .filter-card {
      padding: 0;

      .btn-filter {
        display: flex;
        justify-content: space-between;
        margin-top: 25px;
        padding: 0;

        .btn-ticket {
          align-self: flex-end;
          padding: 8px 55px;
          background: #2F23D6;
          color: #FFFFFF;
          border-radius: 4px !important;
          border: none;
          transition: .2s;

          &:hover {
            background: #20179E;
          }
        }

        .grid-button {
          display: grid;
          grid-gap: 8px;
        }

        .btn-2 {
          padding: 7px 18px;
          color: #ffffff;
          border-radius: 4px !important;
          border: 1px solid #2ACC6B;
          transition: .2s;
          font-size: 14px;
          font-weight: 500;
          background: #2ACC6B;

          &:hover {
            background: #3FB55E;
            color: var(--classic-white);
          }
        }

        .btn-create-ticket {
          display: flex;
          align-items: center;

          padding: 7px 18px;
          color: var(--high-blue);
          border-radius: 4px !important;
          border: 1px solid var(--high-blue);
          transition: .2s;
          font-size: 14px;
          font-weight: 500;
          background: #FFFFFF;

          ion-icon {
            font-size: 17px;
            margin-right: 12px;
          }

          &:hover {
            background: var(--high-blue);
            color: var(--classic-white);
          }
        }
      }
    }

    .filter-card-header {
      display: flex;
      justify-content: space-between;

      .title-filter {
        padding: 0;

        .label-ticket-filter {
          margin: 0;
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: 700;
          color: var(--classic-black);

          ion-icon {
            margin-right: 5px;
            font-size: 23px;
            color: var(--dark-gray);
          }
        }

        span {
          font-size: 14px;
          font-weight: 400;
          color: var(--dark-gray);
        }
      }

      .change-history {
        a {
          color: var(--high-blue);
          font-size: 13px;
          font-weight: 500;
        }
      }
    }

    .label-ticket {
      margin: 0 !important;
      font-size: 24px !important;
      font-weight: bold !important;
      color: $light-black !important;
    }

    .form-group-ticket {
      .group-ticket {
        padding: 0;

        .group-ticket-1 {
          padding: 0;
          margin-top: 25px;

          .input-ticket-1 {
            padding-left: 0;
            padding-right: 15px;

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            .form-ticket-1-input {
              display: flex;
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 10px;
                font-size: 16px;
                color: var(--dark-gray);
              }

              input {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;

                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #CACACA;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #CACACA;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .input-ticket-2 {
            padding-left: 15px;
            padding-right: 15px;

            .select[data-v-4f98b975] {
              margin-bottom: 0;
            }
          }

          .input-ticket-3 {
            padding-left: 15px;
            padding-right: 0;

            .input-ticket-3-select {
              position: relative;

              .custom-checkbox {
                position: absolute;
                top: -24px;
                left: 71px;
              }

            }
          }
        }

        .group-ticket-2 {
          padding: 0;
          margin-top: 15px;

          .input-ticket-4 {
            padding-left: 0;
            padding-right: 15px;

            .input-ticket-4-select {
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 11px;
                font-size: 16px;
                color: var(--dark-gray);
                cursor: pointer;
                pointer-events: none;
              }

              select {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
                cursor: pointer;

                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #CACACA;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #CACACA;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .input-ticket-5 {
            padding-left: 15px;
            padding-right: 15px;

            .input-ticket-5-select {
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 11px;
                font-size: 16px;
                color: var(--dark-gray);
                cursor: pointer;
                pointer-events: none;


              }

              select {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
                cursor: pointer;

                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #CACACA;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #CACACA;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .input-ticket-6 {
            padding-left: 15px;
            padding-right: 0;

            .input-ticket-6-select {
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 11px;
                font-size: 16px;
                color: var(--dark-gray);
                cursor: pointer;
                pointer-events: none;


              }

              select {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
                cursor: pointer;

                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #CACACA;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #CACACA;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }
        }

        .group-ticket-3 {
          padding: 0;
          margin-top: 15px;

          .input-ticket-7 {
            padding-left: 0;
            padding-right: 15px;
          }

          .input-ticket-8 {
            padding-left: 15px;
            padding-right: 15px;

            .input-ticket-8-select {
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 11px;
                font-size: 16px;
                color: var(--dark-gray);
                cursor: pointer;
                pointer-events: none;


              }

              select {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
                cursor: pointer;

                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #CACACA;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #CACACA;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .input-ticket-9 {
            padding-left: 15px;
            padding-right: 0;

            .input-ticket-9-select {
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 11px;
                font-size: 16px;
                color: var(--dark-gray);
                cursor: pointer;
                pointer-events: none;


              }

              select {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
                cursor: pointer;

                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #CACACA;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #CACACA;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .input-ticket-10 {
            margin-top: 20px;
            padding-left: 0;
          }
        }
      }
    }

    .table-box--content {
      min-height: 300px;
      margin-top: 50px;
      padding: 0;
      overflow-x: scroll;
      position: relative;

      .btn-custom {
        position: absolute;
        margin-left: -16px;
        bottom: 0;
        left: 0;
      }

      .content-table {
        width: 100%;
        max-width: 100%;
        min-width: max-content;

        thead {
          font-size: 14px;
          color: var(--high-gray);
          line-height: 220%;
          padding-bottom: 5px;
          border-bottom: 1px solid var(--classic-gray);

          tr {
            th {
              font-weight: 500 !important;
              padding: 0 10px;

              ion-icon {
                width: 13px;
                height: 13px;
                transition: .3s;
                cursor: pointer;
              }
            }
          }
        }

        tbody {
          tr {
            border-bottom: 1px solid var(--classic-gray);

            .content-table--company-name {
              max-width: 200px;
              color: var(--dark-gray);
              padding: 20px 10px;

              .ticket-name {
                display: flex;
                align-items: center;

                input {
                  margin: 0 8px 2px 0;
                  cursor: pointer;
                }
              }

              a {
                display: list-item;
                width: 180px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;
                word-break: break-all;
                font-size: 14px;
                font-weight: 500;
                color: var(--high-blue);
                align-items: center;

                ion-icon {
                  font-size: 14px;
                  margin-right: 4px;
                }
              }

              span {
                display: list-item;
                width: 140px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;
                font-size: 14px;
                font-weight: 500;
                align-items: center;
              }
            }

            .content-table--status {
              max-width: 340px;
              padding-left: 10px;

              span {
                border-radius: 4px !important;
                font-size: 12px;
                font-weight: 500;
                padding: 4px 16px;
              }
            }

            .content-table--value {
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
            }

            .content-table--created {
              text-align: center;
              margin-top: 11px;

              span {
                font-size: 14px;
                font-weight: 400;
                color: var(--dark-gray);
              }
            }

            .content-table-deadline {
              display: flex;
              flex-direction: column;
              align-items: center;

              .is-late {
                border-radius: 4px !important;
                font-size: 12px;
                font-weight: 500;
                padding: 4px 16px;
                background-color: #FF445D;
                color: #FFFFFF;
              }
            }
          }
        }
      }
    }
  }

  .tags {
    padding: 2px 8px;
    border-radius: 4px !important;
    display: inline-block;
    text-align: center;
    margin: 2px;
    color: $classic-white;
  }

  .row {
    margin: 0;
  }
}

.loading-list-table {
  padding: 0;
  box-shadow: none;
  margin-bottom: 0;
}

.no-result-box {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/funnel/tickets.vue